<template>
    <div class="image-clip-modal">
        <!--TitleBaseBox :title="title" :noButton="true" @close="close"-->
        <el-dialog :title="title" :visible="true" width="688px" :append-to-body="true" @close="close">
            <div class="image-clip-upload">
                <input ref="uploadinput" type="file" accept="image/gif,image/jpeg,image/jpg,image/png,image/svg" @change="imageUpload" />
            </div>

            <div class="image-clip-content">
                <div class="image-clip-image" :class="{ 'image-clip-image-bg': hasImage }" ref="imagewrapper">
                    <div class="image-clip-alt" v-if="!hasImage" @click="reLoadImage">
                        <div class="image-add-icon">
                            <Icon bgPosition="-296px 1px" :width="16" />
                        </div>
                        <div>{{ imgAlt }}</div>
                        <div class="image-alt-type">{{ imageType }}</div>
                    </div>
                    <img v-show="hasImage" ref="image" :src="imageUrl" class="image-clip-origin" @load="resetImagePosition" />
                    <ClipMask
                        class="image-clip-mask"
                        :top="maskTop"
                        :left="maskLeft"
                        :width="maskWidth"
                        :height="maskHeight"
                        :isAspact="!!aspectRatio"
                        @moving="clipMoving"
                        @resizing="clipResizing"
                        v-show="hasImage"
                        v-if="data.needClip"
                    />
                </div>
            </div>
            <div class="image-clip-bottom">
                <div class="image-clip-reload" @click="reLoadImage">
                    {{ reloadLabel }}
                    <Icon :width="14" :height="14" bgPosition="-39px -80px" class="clip-reload-icon" />
                </div>
                <div>
                    <RoundButton :text="cancelLabel" @btnClick="cancelClick" class="cancel-btn"></RoundButton>
                    <RoundButton :text="confirmLabel" @btnClick="confirmClick" class="confirm-btn"></RoundButton>
                </div>
            </div>

            <div class="image-clip-canvas">
                <img ref="orginSizeImage" :src="imageUrl" />
                <canvas ref="canvas" :width="cavasWidth" :height="cavasHeight"></canvas>
            </div>
        </el-dialog>
        <!--/TitleBaseBox-->
    </div>
</template>

<script>
import RoundButton from "@/views/zhiji/bComponents/buttons/RoundButton";
import Icon from "@/views/zhiji/bComponents/icons/Icon";
import ClipMask from "./ClipMask";
import { dataURI2Blob } from "@/views/zhiji/js/common/util.js";
import i18n from "@/i18n";

// data={cancel:Function, confirm:Function, aspectRatio, needClip}
export default {
    name: "ImageClipModal",
    props: ["data"],
    components: {
        RoundButton,
        Icon,
        ClipMask
    },
    data() {
        return {
            imageFileName: "",
            imageFileType: "",
            imageUrl: "",
            aspectRatio: this.data.aspectRatio, // 长宽比
            // 图片位置信息
            imageTop: 0,
            imageLeft: 0,
            imageWidth: 0,
            imageHeight: 0,
            // 剪切板位置信息
            maskTop: 120,
            maskLeft: 30,
            maskWidth: 120,
            maskHeight: 100,
            cavasWidth: 1,
            cavasHeight: 1
        };
    },
    computed: {
        reloadLabel() {
            return !this.hasImage ? this.$t("zhiji.materialLibrary.picSelectTip") : this.$t("zhiji.materialLibrary.reUpload");
        },
        hasImage() {
            return this.imageUrl;
        },
        confirmLabel() {
            return this.$t("zhiji.common.confirm");
        },
        cancelLabel() {
            return this.$t("zhiji.common.cancel");
        },
        title() {
            return this.$t("zhiji.materialLibrary.editPic");
        },
        imgAlt() {
            return this.$t("zhiji.materialLibrary.picSelect");
        },
        imageType() {
            return this.$t("zhiji.materialLibrary.picType");
        }
    },
    mounted() {
        this.data.openFile(() => {
            this.$refs.uploadinput.click();
        });
    },
    methods: {
        reLoadImage() {
            this.$refs.uploadinput.click();
        },
        close() {
            this.data.cancel && this.data.cancel();
            this.$emit("closeModal");
        },
        cancelClick() {
            this.close();
        },
        confirmClick() {
            if (this.confirmed) {
                return;
            }
            this.confirmed = true;

            if (!this.data.needClip) {
                this.requestUpload();
                return;
            }

            let width = this.$refs.orginSizeImage.width;
            let height = this.$refs.orginSizeImage.height;
            this.cavasWidth = (width * this.maskWidth) / this.imageWidth;
            this.cavasHeight = (height * this.maskHeight) / this.imageHeight;
            let sLeft = (width * (this.maskLeft - this.imageLeft)) / this.imageWidth;
            let sTop = (height * (this.maskTop - this.imageTop)) / this.imageHeight;

            setTimeout(() => {
                let ctx = this.$refs.canvas.getContext("2d");
                ctx.drawImage(this.$refs.orginSizeImage, sLeft, sTop, this.cavasWidth, this.cavasHeight, 0, 0, this.cavasWidth, this.cavasHeight);
                this.imageUrl = this.$refs.canvas.toDataURL(this.imageFileType);

                this.requestUpload();
            });
        },
        requestUpload() {
            let formData = new FormData();
            formData.append("file", dataURI2Blob(this.imageUrl), this.imageFileName);
            this.zhiji
                .requestByServiceName("uploadImage", formData)
                .then(result => {
                    this.data.confirm && this.data.confirm(result.url);
                    this.close();
                })
                .catch(err => {
                    this.confirmed = true;
                    throw err;
                });
        },
        imageUpload(event) {
            let imageFile = event.target.files[0];

            if (!imageFile) {
                this.imgAlt = i18n.t("zhiji.materialLibrary.picSelect");
                return;
            }

            if (imageFile.size > 1024 * 1024 * 1) {
                this.imgAlt = i18n.t("zhiji.materialLibrary.maxPicSize");
                return;
            }

            this.imageFileName = imageFile.name;
            this.imageFileType = imageFile.type;
            let reader = new FileReader();

            reader.onload = () => {
                let url = reader.result;
                this.imageUrl = url;
                reader.onload = null;
            };

            reader.readAsDataURL(imageFile);
        },
        clipMoving(pos) {
            let newTop = this.maskTop + pos.y;
            let newLeft = this.maskLeft + pos.x;

            if (this.isVerticalOuter(newTop, this.maskHeight) === 1) {
                this.maskTop = this.imageTop;
            } else if (this.isVerticalOuter(newTop, this.maskHeight) === -1) {
                this.maskTop = this.imageTop + this.imageHeight - this.maskHeight;
            } else {
                this.maskTop = newTop;
            }

            if (this.isHorizenOuter(newLeft, this.maskWidth) === 1) {
                this.maskLeft = this.imageLeft;
            } else if (this.isHorizenOuter(newLeft, this.maskWidth) === -1) {
                this.maskLeft = this.imageLeft + this.imageWidth - this.maskWidth;
            } else {
                this.maskLeft = newLeft;
            }
        },
        resetImagePosition(event) {
            const target = event.target;
            this.setImagePosition(target);
        },
        setImagePosition(imageElem) {
            const imageWrapperRect = this.$refs.imagewrapper.getBoundingClientRect();
            const imageRect = imageElem.getBoundingClientRect();

            // 图片本身位置
            this.imageTop = imageRect.top - imageWrapperRect.top;
            this.imageLeft = imageRect.left - imageWrapperRect.left;
            this.imageWidth = imageRect.width;
            this.imageHeight = imageRect.height;

            // 剪切板初始化位置
            this.maskTop = this.imageTop;
            this.maskLeft = this.imageLeft;

            let aspectRatio = this.aspectRatio || 4 / 3;
            let width = this.imageWidth;
            let height = width / aspectRatio; // Math.floor
            if (height > this.imageHeight) {
                this.maskWidth = this.imageHeight * aspectRatio; //Math.floor
                this.maskHeight = this.imageHeight;
            } else {
                this.maskWidth = this.imageWidth;
                this.maskHeight = height;
            }
        },
        isVerticalOuter(top, height) {
            if (top < this.imageTop) {
                return 1;
            } else if (top + height > this.imageTop + this.imageHeight) {
                return -1;
            }

            return false;
        },
        isHorizenOuter(left, width) {
            if (left < this.imageLeft) {
                return 1;
            } else if (left + width > this.imageLeft + this.imageWidth) {
                return -1;
            }

            return false;
        },
        clipResizing(pos) {
            this.aspectRatio ? this.resizingRate(pos) : this.resizingNoRate(pos);
        },
        resizingNoRate(pos) {
            const direct = pos.direct;

            if (direct.indexOf("top") !== -1) {
                pos.y && this.resizingTop(pos.y);
            }
            if (direct.indexOf("bottom") !== -1) {
                pos.y && this.resizingBottom(pos.y);
            }
            if (direct.indexOf("left") !== -1) {
                pos.x && this.resizingLeft(pos.x);
            }
            if (direct.indexOf("right") !== -1) {
                pos.x && this.resizingRight(pos.x);
            }
        },
        resizingRate(pos) {
            const direct = pos.direct;

            if (direct == "top") {
                this.resizingTopRate(pos.y);
            } else if (direct == "bottom") {
                this.resizingBottomRate(pos.y);
            } else if (direct == "left") {
                this.resizingLeftRate(pos.x);
            } else if (direct == "right") {
                this.resizingRightRate(pos.x);
            }
        },
        resizingTop(change) {
            this.resizingStart(change, "Top");
        },
        resizingTopRate(change) {
            let resizeWidth = Math.abs(change) * this.aspectRatio; // Math.floor
            let resizingLeft = resizeWidth / 2; // Math.floor
            let resizingRight = resizeWidth - resizingLeft;

            if (change > 0 && Math.abs(change) < this.maskHeight) {
                this.resizingTop(change);
                this.resizingLeft(resizingLeft);
                this.resizingRight(-1 * resizingRight);
            } else if (change < 0) {
                if (change + this.maskTop < this.imageTop) {
                    return this.resizingTopRate(this.imageTop - this.maskTop);
                }

                if (resizingLeft > this.maskLeft - this.imageLeft) {
                    resizingLeft = this.maskLeft - this.imageLeft;
                    return this.resizingTopRate(-1 * ((resizingLeft * 2) / this.aspectRatio)); // Math.floor
                }

                if (resizingRight > this.imageWidth + this.imageLeft - this.maskLeft - this.maskWidth) {
                    resizingRight = this.imageWidth + this.imageLeft - this.maskLeft - this.maskWidth;
                    return this.resizingTopRate(-1 * ((resizingRight * 2) / this.aspectRatio)); // Math.floor
                }

                this.resizingTop(change);
                this.resizingLeft(-1 * resizingLeft);
                this.resizingRight(resizingRight);
            }
        },
        resizingBottom(change) {
            this.resizingEnd(change, "Top");
        },
        resizingBottomRate(change) {
            let resizeWidth = Math.abs(change) * this.aspectRatio; // Math.floor
            let resizingLeft = resizeWidth / 2; // Math.floor
            let resizingRight = resizeWidth - resizingLeft;

            if (change < 0) {
                this.resizingBottom(change);
                this.resizingLeft(resizingLeft);
                this.resizingRight(-1 * resizingRight);
            } else if (change > 0 && Math.abs(change) < this.maskHeight) {
                if (change + this.maskTop + this.maskHeight > this.imageTop + this.imageHeight) {
                    return this.resizingBottomRate(this.imageTop + this.imageHeight - this.maskTop - this.maskHeight);
                }

                if (resizingLeft > this.maskLeft - this.imageLeft) {
                    resizingLeft = this.maskLeft - this.imageLeft;
                    return this.resizingBottomRate((resizingLeft * 2) / this.aspectRatio); // Math.floor
                }

                if (resizingRight > this.imageWidth + this.imageLeft - this.maskLeft - this.maskWidth) {
                    resizingRight = this.imageWidth + this.imageLeft - this.maskLeft - this.maskWidth;
                    return this.resizingBottomRate((resizingRight * 2) / this.aspectRatio); // Math.floor
                }

                this.resizingBottom(change);
                this.resizingLeft(-1 * resizingLeft);
                this.resizingRight(resizingRight);
            }
        },
        resizingLeft(change) {
            this.resizingStart(change, "Left");
        },
        resizingLeftRate(change) {
            let resizeHeight = Math.abs(change) / this.aspectRatio; // Math.floor
            let resizingTop = resizeHeight / 2; // Math.floor
            let resizingBottom = resizeHeight - resizingTop;

            if (change > 0 && Math.abs(change) < this.maskWidth) {
                this.resizingLeft(change);
                this.resizingTop(resizingTop);
                this.resizingBottom(-1 * resizingBottom);
            } else if (change < 0) {
                if (change + this.maskLeft < this.imageLeft) {
                    return this.resizingLeftRate(this.imageLeft - this.maskLeft);
                }

                if (resizingTop > this.maskTop - this.imageTop) {
                    resizingTop = this.maskTop - this.imageTop;
                    return this.resizingLeftRate(-1 * (resizingTop * 2 * this.aspectRatio)); // Math.floor
                }

                if (resizingBottom > this.imageHeight + this.imageTop - this.maskTop - this.maskHeight) {
                    resizingBottom = this.imageHeight + this.imageTop - this.maskTop - this.maskHeight;
                    return this.resizingLeftRate(-1 * (resizingBottom * 2 * this.aspectRatio)); // Math.floor
                }

                this.resizingLeft(change);
                this.resizingTop(-1 * resizingTop);
                this.resizingBottom(resizingBottom);
            }
        },
        resizingRight(change) {
            this.resizingEnd(change, "Left");
        },
        resizingRightRate(change) {
            let resizeHeight = Math.abs(change) / this.aspectRatio; // Math.floor
            let resizingTop = resizeHeight / 2; // Math.floor
            let resizingBottom = resizeHeight - resizingTop;

            if (change < 0) {
                this.resizingRight(change);
                this.resizingTop(resizingTop);
                this.resizingBottom(-1 * resizingBottom);
            } else if (change > 0 && Math.abs(change) < this.maskWidth) {
                if (change + this.maskLeft + this.maskWidth > this.imageLeft + this.imageWidth) {
                    return this.resizingRightRate(this.imageLeft + this.imageWidth - this.maskLeft - this.maskWidth);
                }

                if (resizingTop > this.maskTop - this.imageTop) {
                    resizingTop = this.maskTop - this.imageTop;
                    return this.resizingRightRate(resizingTop * 2 * this.aspectRatio); // Math.floor
                }

                if (resizingBottom > this.imageHeight + this.imageTop - this.maskTop - this.maskHeight) {
                    resizingBottom = this.imageHeight + this.imageTop - this.maskTop - this.maskHeight;
                    return this.resizingRightRate((resizingBottom * 2) / this.aspectRatio); // Math.floor
                }

                this.resizingRight(change);
                this.resizingTop(-1 * resizingTop);
                this.resizingBottom(resizingBottom);
            }
        },
        resizingStart(change, startTag = "Top") {
            let newStart = this["mask" + startTag] + change;
            let lenTag = "mask" + ("Top" == startTag ? "Height" : "Width");

            if (newStart < this["image" + startTag]) {
                newStart = this["image" + startTag];
            } else if (this[lenTag] - change <= 1) {
                return;
            }

            this[lenTag] = this[lenTag] + this["mask" + startTag] - newStart;
            this["mask" + startTag] = newStart;
        },
        resizingEnd(change, startTag = "Top") {
            let lenTag = "Top" == startTag ? "Height" : "Width";
            let newLen = this["mask" + lenTag] + change;

            if (newLen <= 1) {
                return;
            } else if (newLen + this["mask" + startTag] > this["image" + startTag] + this["image" + lenTag]) {
                newLen = this["image" + startTag] + this["image" + lenTag] - this["mask" + startTag];
            }

            this["mask" + lenTag] = newLen;
        }
    }
};
</script>

<style lang="scss" scoped>
/*.image-clip-modal {
    height: 100%;
    width: 100%;
    background: rgba(65, 71, 94, 0.4);
    display: flex;
    align-items: center;
    justify-content: space-around;*/
.image-clip-content {
    width: 640px;
    box-sizing: border-box;
    padding-bottom: 16px;
    border-bottom: 1px solid #dce6f0;
}
.image-clip-alt {
    text-align: center;
    cursor: pointer;

    .image-add-icon {
        width: 44px;
        height: 44px;
        border-radius: 50%;
        box-shadow: 0 2px 12px rgba(46, 98, 151, 0.2);
        margin-bottom: 10px;
        display: inline-flex;
        align-items: center;
        justify-content: space-around;
    }

    .image-alt-type {
        color: #999;
    }
}

.image-clip-image {
    position: relative;
    height: 480px;
    display: flex;
    align-items: center;
    justify-content: space-around;
}

.image-clip-image-bg {
    background: url($zhijiStaticImagePath+"pic-mask-bg.png");
}

.image-clip-origin {
    max-width: 100%;
    max-height: 100%;
}

.image-clip-mask {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
}

.image-clip-bottom {
    padding-top: 20px;
    display: flex;
    align-items: center;
    justify-content: flex-end;
}

.clip-reload-icon {
    vertical-align: -2px;
    margin-left: 1px;
}

.image-clip-reload {
    position: absolute;
    left: 24px;
    cursor: pointer;

    &:hover {
        color: #2ec2ff;
        .clip-reload-icon {
            background-position: -39px -95px !important;
        }
    }
}

.cancel-btn {
    border: 1px solid #d8e4f0;
    box-shadow: none !important;
    background-color: #fff !important;
    color: rgba(65, 71, 94, 0.9) !important;
    margin-right: 6px;

    &:hover {
        color: #2ec2ff !important;
    }
}

.confirm-btn {
    margin-right: 0;
    box-shadow: none !important;
}

.image-clip-upload {
    display: none;
}

.image-clip-canvas {
    position: absolute;
    display: none;
}
/*}*/
</style>
